var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .167A2.167 2.167 0 0 1 9.163 2.21l.004.122h3.5a.5.5 0 0 1 .068.996l-.068.004h-.531l-.853 8.68a1.834 1.834 0 0 1-1.708 1.65l-.117.004H4.542a1.833 1.833 0 0 1-1.81-1.538l-.015-.116-.854-8.68h-.53a.5.5 0 0 1-.495-.432l-.005-.068a.5.5 0 0 1 .432-.495l.068-.005h3.5A2.167 2.167 0 0 1 7 .167zm4.131 3.166H2.868l.845 8.582a.833.833 0 0 0 .744.748l.085.004h4.916c.4 0 .74-.284.817-.668l.013-.084.843-8.582zM8.167 5.167a.5.5 0 0 1 .495.432l.005.068v4.666a.5.5 0 0 1-.996.068l-.004-.068V5.667a.5.5 0 0 1 .5-.5zm-2.334 0a.5.5 0 0 1 .496.432l.004.068v4.666a.5.5 0 0 1-.995.068l-.005-.068V5.667a.5.5 0 0 1 .5-.5zm1.167-4a1.167 1.167 0 0 0-1.163 1.07l-.004.096h2.334A1.167 1.167 0 0 0 7 1.167z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.a47b8ebc97a68360be73325c7a9d78d8.svg";
export { ForwardRef as ReactComponent };